<template>
    <form class="card">
        <h3>Параметры</h3>
        <ParkingConfig v-if="status == ''" @showPopup="showPopup" :data.sync="data"></ParkingConfig>
    </form>
</template>

<script>
    import ParkingConfig from '@/components/forms/ParkingConfig.vue'
    export default {
        props: ['status', 'data'],
        components: {
            ParkingConfig
        },
        created () {
            this.$emit('getData')
        },
        methods: {
            showPopup (data) {
                this.$emit('showPopup', data)
            }
        }
    }
</script>